import { useState, useEffect } from 'react';
import { X, Mail, Send } from 'lucide-react';

const NEWSLETTER_URL = "http://eepurl.com/jCnhRE";

export const NewsletterPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user has dismissed the popup before
    const dismissed = localStorage.getItem('newsletterPopupDismissed');
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    // Show popup after 3 seconds
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
    // Remember dismissal for 7 days
    localStorage.setItem('newsletterPopupDismissed', Date.now().toString());
  };

  const handleSubscribe = () => {
    // Open newsletter signup in new tab
    window.open(NEWSLETTER_URL, '_blank', 'noopener,noreferrer');
    handleDismiss();
  };

  if (isDismissed || !isVisible) return null;

  return (
    <div 
      className="fixed bottom-4 right-4 z-50 animate-slide-up"
      data-testid="newsletter-popup"
    >
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 w-80 overflow-hidden">
        {/* Header */}
        <div className="bg-wv-blue p-4 relative">
          <button
            onClick={handleDismiss}
            className="absolute top-2 right-2 text-white/80 hover:text-white transition-colors"
            aria-label="Close popup"
            data-testid="popup-close-button"
          >
            <X className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-wv-red rounded-full flex items-center justify-center">
              <Mail className="w-5 h-5 text-white" />
            </div>
            <div>
              <h3 className="font-heading text-lg font-bold text-white">
                Stay Connected
              </h3>
              <p className="text-white/80 text-sm">
                Get veteran resources & updates
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-4">
          <p className="text-gray-600 text-sm mb-4">
            Subscribe to our newsletter for the latest VA updates, tips, and resources for veterans.
          </p>
          <button
            onClick={handleSubscribe}
            className="w-full bg-wv-red text-white font-bold py-3 px-4 rounded-lg hover:bg-red-700 transition-colors flex items-center justify-center gap-2"
            data-testid="popup-subscribe-button"
          >
            <Send className="w-4 h-4" />
            Subscribe Now
          </button>
          <button
            onClick={handleDismiss}
            className="w-full text-gray-500 text-sm mt-2 hover:text-gray-700 transition-colors"
            data-testid="popup-dismiss-button"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};
